import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/interfaces';
import { AppService } from 'src/app/services/app.service';
import { FiltersActions } from '../../../state/actions/filters/filters-action-types';
import { FiltersAccessor } from '../../accessors/filters.accessor';

@Injectable()
export class FiltersFacade {
  constructor(
    private app: AppService,
    private store: Store<State>,
    private accessor: FiltersAccessor,
  ) {
    app.expose('facades', 'filters', this);
  }

  get state() {
    return this.accessor;
  }

  setFilters(type, filters){
    if(type === 'shifts'){
      this.store.dispatch(FiltersActions.setShiftsFilters({filters}));
    }else if(type === 'timecards'){
      this.store.dispatch(FiltersActions.setTimecardsFilters({filters}));
    }
  }
}
